export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.88 20.49">
    <path d="M7.44 20.49A.68.68 0 0 1 7 20.3c-.33-.3-7-6.48-7-12.86a7.44 7.44 0 0 1 14.88 0c0 6.38-6.68 12.6-7 12.86a.7.7 0 0 1-.44.19zm0-19.07a6 6 0 0 0-6 6c0 4.82 4.51 9.82 6 11.35 1.5-1.53 6-6.53 6-11.35a6 6 0 0 0-6-6zm0 9.25A3.65 3.65 0 1 1 11.08 7a3.65 3.65 0 0 1-3.64 3.67zm0-5.87A2.23 2.23 0 1 0 9.66 7a2.23 2.23 0 0 0-2.22-2.2z" />
  </svg>
);
